import { Vue, Component } from 'vue-property-decorator'
import { State, Action } from 'vuex-class';
@Component
export default class PaginationMixin extends Vue {
  // @ts-ignore
  @Action('setTableOptions', { namespace: 'tableFilters' }) setTableOptions: (
    payload: object,
  ) => void;
  @State('options', { namespace: 'tableFilters' }) options: object;
  get moduleOptions() {
    // @ts-ignore
    return this.options[this.namespace] || {};
  }
  setPooling() {
    // @ts-ignore
    this.interval = setInterval(() => {
      // @ts-ignore
      this.getEntities();
    }, 5000);
  }
  // @ts-ignore
  set moduleOptions(value) {
    // @ts-ignore
    this.setTableOptions({ module: this.namespace, data: { ...value, multiSort: false } }).then(() => {
      // @ts-ignore
      this.getEntities();
      // @ts-ignore
      if (this.interval === null) {
        this.setPooling();
      }
    });
  }
  beforeDestroy() {
    // @ts-ignore
    clearInterval(this.interval);
  }

}